import { Configuration, LogLevel } from '@azure/msal-browser';

async function getClientId() {
    await refreshWebApiClientId();
    const response = await fetch('/env/getClientId', { method: "GET" });
    const data = await response.text();
    localStorage.setItem('MpWebAppClientId', data);
    return data;
}

async function getTenantId() {
    await refreshWebApiClientId();
    const response = await fetch('/env/getTenantId', { method: "GET" });
    const data = await response.text();
    localStorage.setItem('MpWebAppTenantId', data);
    return data;
}

async function refreshWebApiClientId() {
    if (!localStorage.getItem("MpWebApiClientId")) {
        const response = await fetch('/env/getWebApiClientId', { method: "GET" });
        const data = await response.text();
        localStorage.setItem('MpWebApiClientId', data);
        return data;
    }
}

// MSAL configuration
export const msalConfig: Configuration = {
    auth: {
        clientId: await getClientId() || "missing_client_id_config",
        authority: "https://login.microsoftonline.com/" + await getTenantId()
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string) => {
                console.log(message);
            },
            logLevel: LogLevel.Verbose,
            piiLoggingEnabled: false
        }
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
    scopes: ["openid", "profile", "email"]
}; 